import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getWarehouseList = createAsyncThunk("warehouse/list", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}warehouse/api/v1/list`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("Warehouse response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching warehose:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});
